import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import { themeColor } from '@elparking/components'
import { heightSize, width } from 'commons/js/theme/styles'
import { FONT_SIZES, COLORS } from '../../theme/default'

const flicker = keyframes`
  0% {
    opacity: 0;
  }

  50% {
      opacity: 1;
  }

  100% {
    opacity: 0;
  }
`

const LoadingBlock = styled.div`
    ${heightSize}
    ${width}
    margin-bottom: -2px;
    display: inline-block;
    background: ${({ color }) => themeColor(color)};
    animation: ${flicker} ${({seconds}) => seconds}s linear infinite;
`

LoadingBlock.propTypes = {
    seconds: PropTypes.number.isRequired,
    size: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf(FONT_SIZES),
      PropTypes.arrayOf(PropTypes.oneOf(FONT_SIZES)),
    ]),
    color: PropTypes.oneOf(COLORS),
}

LoadingBlock.defaultProps = {
    color: 'gray20',
    seconds: 3,
    size: 'xxSmall',
}

export { FONT_SIZES, COLORS }

export default LoadingBlock
